// 检查当前域名是否pt旧域名，重定向到新域名
import { MessageBox } from 'element-ui'
import i18n from '@/lang'

export function checkOldDomainAndRedirect() {
  // 获取当前域名
  const currentDomain = window.location.hostname

  // 定义需要检查的域名
  const domainsToCheck = [
    'playturbo.mindworks-creative.cn',
    'playturbo.mindworks-creative.com',
  ]

  // 定义跳转目标域名
  const targetDomains = {
    'playturbo.mindworks-creative.cn': 'app.playturbo.cn',
    'playturbo.mindworks-creative.com': 'app.playturbo.com',
  }

  // 检查当前域名是否需要跳转
  if (domainsToCheck.includes(currentDomain)) {
    MessageBox.confirm(
      i18n.t('playTurbo.common.domain.tips.content').toString(),
      i18n.t('playTurbo.common.domain.tips.title').toString(),
      {
        confirmButtonText: i18n
          .t('playTurbo.common.domain.tips.submit')
          .toString(),
        showCancelButton: false,
        type: 'warning',
        center: true,
        customClass: 'domain-confrim-dialog',
      },
    ).finally(() => {
      // 获取目标域名
      const targetDomain = targetDomains[currentDomain]
      // 构建跳转URL
      const targetUrl =
        window.location.protocol +
        '//' +
        targetDomain +
        window.location.pathname +
        window.location.search +
        window.location.hash

      // 执行跳转
      window.location.href = targetUrl
    })
  }
}
